import React from "react";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      It can be hugely frustrating when you have an inkling
                      about what it is you want to do but the steps you need to
                      take to get there aren’t clear. It can feel a bit like
                      standing at the foot of a mountain, you know where you
                      need to get to but the path isn’t clear. The secret to
                      making progress and making things happen is taking action.
                      Yes, you might find you get a little lost now and again
                      and have to navigate some potential obstacles, but all the
                      while you'll be getting closer to the top. It's the same
                      with your next-step careers thinking.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
